module.exports = __webpack_public_path__ + "static/img/mystery-box2.246e469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/mystery-box2.png
// module id = EwrG
// module chunks = 216